import Ajax from '../../../lib/ajax';
import { ActionContext } from 'vuex';

interface DashboardTransactionState {
    loading: boolean;
    summaries: Record<string, any>;
}

const state: DashboardTransactionState = {
    loading: false,
    summaries: {},
};

const dashboardTransactionModule = {
    namespaced: true,
    state,
    actions: {
        async getSummary(
            context: ActionContext<DashboardTransactionState, any>,
            payload: { schema: string; params: any }
        ) {
            context.state.loading = true;
            try {
                const response = await Ajax.get('/api/dashboard/summary', {
                    params: { ...payload.params, schema: payload.schema }
                });
                context.commit('setSummary', {
                    schema: payload.schema,
                    data: response.data.result
                });
                return response.data.result;
            } catch (error) {
                return Promise.reject(error);
            } finally {
                context.state.loading = false;
            }
        },
    },
    mutations: {
        setSummary(state: DashboardTransactionState, payload: { schema: string; data: any }) {
            state.summaries[payload.schema] = payload.data;
        },
    },
};

export default dashboardTransactionModule;
